import React from "react";
import { default as RGL, WidthProvider } from "react-grid-layout";
import PBar from "./PBar";
import PCard from "./PCard";
import PPie from "./PPie";

const ReactGridLayout = WidthProvider(RGL);

export default function PPemprodifabel({ loading, data, subtext, tahun }) {
  return (
    <React.Fragment>
      {/* <ReactGridLayout className="layout" cols={12} rowHeight={30}>
        <div key="z" data-grid={{ x: 0, y: 0, w: 6, h: 3, static: true }}>
          <React.Fragment>
            {data?.stats_total_pttpk && (
              <PCard
                text="Non PNS (PTT-PK/BLUD)"
                loading={loading}
                total={data?.stats_total_pttpk[0]?.total}
                secondaryColor="pttpk"
              />
            )}
          </React.Fragment>
        </div>
        <div key="x" data-grid={{ x: 6, y: 0, w: 6, h: 3, static: true }}>
          <React.Fragment>
            {data?.stats_total_gtt && (
              <PCard
                text="GTT/PTT DINDIK"
                loading={loading}
                total={data?.stats_total_gtt[0]?.total}
                secondaryColor="gtt"
              />
            )}
          </React.Fragment>
        </div>
      </ReactGridLayout> */}
      {/* pembagian fungsional */}
      <ReactGridLayout className="layout" cols={12} rowHeight={30}>
        <div key="bc" data-grid={{ x: 0, y: 0, w: 3, h: 3, static: true }}>
          <React.Fragment>
            {data?.stats_fungsional_prov_jatim && (
              <PCard
                text="Disabilitas Sensorik"
                secondaryColor="fungsional"
                loading={loading}
                total={data?.stats_fungsional_prov_jatim[0]?.fungsional_medis}
              />
            )}
          </React.Fragment>
        </div>
        <div key="cb" data-grid={{ x: 3, y: 0, w: 3, h: 3, static: true }}>
          <React.Fragment>
            {data?.stats_fungsional_prov_jatim && (
              <PCard
                text="Disabilitas Intelektual"
                secondaryColor="fungsional"
                loading={loading}
                total={
                  data?.stats_fungsional_prov_jatim[0]?.fungsional_paramedis
                }
              />
            )}
          </React.Fragment>
        </div>
        <div key="de" data-grid={{ x: 6, y: 0, w: 3, h: 3, static: true }}>
          <React.Fragment>
            {data?.stats_fungsional_prov_jatim && (
              <PCard
                text="Disabilitas Mental"
                secondaryColor="fungsional"
                loading={loading}
                total={data?.stats_fungsional_prov_jatim[0]?.fungsional_guru}
              />
            )}
          </React.Fragment>
        </div>
        <div key="ef" data-grid={{ x: 9, y: 0, w: 3, h: 3, static: true }}>
          <React.Fragment>
            {data?.stats_fungsional_prov_jatim && (
              <PCard
                text="Disabilitas Fisik"
                secondaryColor="fungsional"
                loading={loading}
                total={data?.stats_fungsional_prov_jatim[0]?.fungsional_lainnya}
              />
            )}
          </React.Fragment>
        </div>
      </ReactGridLayout>
      <ReactGridLayout className="layout" cols={12} rowHeight={30}>
        <div key="a" data-grid={{ x: 0, y: 0, w: 3, h: 3, static: true }}>
          <PCard
            text="Pegawai"
            loading={loading}
            total={`${
              data?.gender?.aggregate?.sum?.pria +
              data?.gender?.aggregate?.sum?.wanita
            }`}
          />
        </div>
        <div key="b" data-grid={{ x: 3, y: 0, w: 3, h: 3, static: true }}>
          <PCard
            text="Struktural"
            secondaryColor="struktural"
            loading={loading}
            total={`${data?.jabatan?.aggregate?.sum?.struktural}`}
          />
        </div>
        <div key="c" data-grid={{ x: 6, y: 0, w: 3, h: 3, static: true }}>
          <PCard
            text="Fungsional"
            loading={loading}
            secondaryColor="fungsional"
            total={`${data?.jabatan?.aggregate?.sum?.fungsional}`}
          />
        </div>
        <div key="d" data-grid={{ x: 9, y: 0, w: 3, h: 3, static: true }}>
          <PCard
            text="Pelaksana"
            secondaryColor="pelaksana"
            loading={loading}
            total={`${data?.jabatan?.aggregate?.sum?.pelaksana}`}
          />
        </div>
        <div key="e" data-grid={{ x: 0, y: 3, w: 6, h: 7, static: true }}>
          <PBar
            loading={loading}
            data={data?.gender?.aggregate?.sum}
            title="Jenis Kelamin"
            subText={subtext}
          />
        </div>
        <div key="g" data-grid={{ x: 6, y: 3, w: 6, h: 7, static: true }}>
          <PBar
            loading={loading}
            data={data?.eselon?.aggregate?.sum}
            title="Eselon"
            subText={subtext}
            list={["Ia", "Ib", "IIa", "IIb", "IIIa", "IIIb", "IVa", "IVb"]}
          />
        </div>
        <div key="f" data-grid={{ x: 0, y: 10, w: 12, h: 12, static: true }}>
          <PPie
            loading={loading}
            data={data?.umur?.aggregate.sum}
            title="Usia"
            subText={subtext}
          />
        </div>
        <div key="h" data-grid={{ x: 0, y: 22, w: 12, h: 8, static: true }}>
          <PBar
            loading={loading}
            data={data?.pendidikan?.aggregate?.sum}
            title="Pendidikan"
            subText={subtext}
          />
        </div>
        <div key="i" data-grid={{ x: 0, y: 30, w: 12, h: 8, static: true }}>
          <PBar
            loading={loading}
            data={data?.golongan?.aggregate?.sum}
            title="Golongan"
            subText={subtext}
          />
        </div>
        {/* <div key="j" data-grid={{ x: 0, y: 38, w: 6, h: 3, static: true }}>
          <PCard
            text={`Prediksi Batas Usia Pensiun tahun ${tahun}`}
            loading={loading}
            total={`${data?.bup?.aggregate?.sum?.total}`}
          />
        </div>
        <div key="k" data-grid={{ x: 6, y: 38, w: 6, h: 3, static: true }}>
          <PCard
            text={`Prediksi Kenaikan Pangkat tahun ${tahun}`}
            loading={loading}
            total={`${data?.kp_reguler?.aggregate?.sum?.total}`}
          />
        </div> */}
      </ReactGridLayout>
    </React.Fragment>
  );
}
